module.exports = __webpack_public_path__ + "static/img/cer_item_logo.bf27a049.png";